import { Post } from "../../FeedPost";
import {
  handleRedirect,
  handleShop,
  handleTagged,
} from "../../../../Utils/SupabaseServices/Track";
import { useLocation } from "react-router-dom";
import "./PinterestPost.css";
import Caption from "../Caption";

import "../CommentsPost/CommentsPost.css";
import PostInfo from "../../PostInfo/PostInfo";

export type PinterestPostType = Post & {
  platform: "pinterest";
  metadata: {
    description: string;
  };
};

export default function PinterestPost({
  post,
  showCaption,
  shoppableContent,
  user_id,
  showAsAd,
  platform,
  username,
  name,
}: {
  post: PinterestPostType;
  showCaption: any;
  isGlobalView: any;
  shoppableContent: any;
  user_id: any;
  showAsAd: any;
  platform: any;
  username: any;
  name: string;
}) {
  const location = useLocation();
  const {
    post_date,
    post_id,
    permalink,
    media_url,
    shop_link,
    tagged_link,
    external_link,
  } = post;

  return (
    <div>
      <div className="pinterest-post-img-wrp">
        <img
          src={post.media_url}
          alt={post.caption}
          className="pinterest-post-img bg-f1"
        />
      </div>

      <PostInfo
        username={username}
        user_id={user_id}
        showAsAd={showAsAd}
        post_date={post_date}
        permalink={permalink}
        shop_link={shop_link}
        tagged_link={tagged_link}
        external_link={external_link}
        post_id={post_id}
        handleRedirect={handleRedirect}
        handleShop={handleShop}
        handleTagged={handleTagged}
        platform={platform}
        media_url={media_url}
        shoppableContent={shoppableContent}
        name={name}
      />
      {post?.caption && <Caption caption={post.caption} />}
    </div>
  );
}
